/**
 * Manage Recently Viewed Products Action
 * Triggered by: arc:action:recentlyViewedManage
 */

export const runRecentlyViewedManage = async (data = {}) => {
    try {
        const { action = 'clear', productId, limit = 20 } = data;

        // Get current products
        const currentProducts = JSON.parse(localStorage.getItem("recentlyviewed_products") || "[]");

        let updatedProducts = [...currentProducts];
        let message = '';

        switch (action) {
            case 'clear':
                // Clear all recently viewed products
                updatedProducts = [];
                message = 'Recently viewed products cleared';
                break;

            case 'remove':
                // Remove specific product by ID
                if (!productId) {
                    throw new Error('Product ID is required for remove action');
                }
                updatedProducts = currentProducts.filter(product => 
                    parseInt(product.id) !== parseInt(productId)
                );
                message = 'Product removed from recently viewed';
                break;

            case 'trim':
                // Trim to specified limit
                updatedProducts = currentProducts.slice(0, limit);
                message = `Recently viewed list trimmed to ${limit} products`;
                break;

            default:
                throw new Error(`Unknown action: ${action}`);
        }

        // Save updated list to localStorage
        localStorage.setItem("recentlyviewed_products", JSON.stringify(updatedProducts));

        // Dispatch update event
        window.dispatchEvent(new CustomEvent('recentlyViewed:updated', {
            detail: {
                products: updatedProducts,
                action: action,
                removedProductId: action === 'remove' ? productId : null
            }
        }));

        return {
            success: true,
            products: updatedProducts,
            action: action,
            message: message
        };

    } catch (error) {
        console.error('Recently Viewed Manage error:', error);
        
        // Dispatch error event
        window.dispatchEvent(new CustomEvent('recentlyViewed:error', {
            detail: {
                error: error.message,
                action: 'manage'
            }
        }));

        return {
            success: false,
            error: error.message
        };
    }
};

export default runRecentlyViewedManage;
